// Shared formatting utility functions

/**
 * Format a number with locale-aware decimal places
 * @param {number} n - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number or '--' if invalid
 */
export const fmtNum = (n, decimals = 2) => {
    if (n == null || isNaN(n)) return '--';
    return Number(n).toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

/**
 * Format market cap with T/B/M suffix
 * @param {number} n - Market cap value
 * @returns {string} Formatted market cap string
 */
export const fmtMarketCap = (n) => {
    if (!n) return '--';
    if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
    if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
    if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
    return `$${Number(n).toLocaleString()}`;
};

/**
 * Format percentage with sign
 * @param {number} value - Percentage value
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted percentage with sign
 */
export const fmtPercent = (value, decimals = 2) => {
    if (value == null || isNaN(value)) return '--';
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(decimals)}%`;
};

/**
 * Format price in dollars
 * @param {number} price - Price value
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted price with $ prefix
 */
export const fmtPrice = (price, decimals = 2) => {
    if (price == null || isNaN(price)) return '--';
    return `$${fmtNum(price, decimals)}`;
};

export default {
    fmtNum,
    fmtMarketCap,
    fmtPercent,
    fmtPrice,
};
